export const UserPermissions = {
    "CMS": [
        "R",
        "C",
        "U",
        "T",
        "D"
    ],
    "Bonus": [
        "R",
        "C",
        "U",
        "D",
        "T",
        "Issue"
    ],
    "Users": [
        "R",
        "U",
        "SR",
        "AB",
        "T",
        "EV",
        "UP",
        "D"
    ],
    "Admins": [
        "R",
        "C",
        "U",
        "D",
        "T"
    ],
    // "Reviews": [
    //     "R",
    //     "C",
    //     "U"
    // ],
    // "KycLabel": [
    //     "R",
    //     "C",
    //     "U"
    // ],
    "KpiReport": [
        "R"
    ],
    // "Currencies": [
    //     "R",
    //     "C",
    //     "U",
    //     "T"
    // ],
    "GameReport": [
        "R"
    ],
    "BetSettings": [
        "R",
        "C",
        "U",
        "D"
    ],
    "UserComment": [
         "R",
        "C",
    ],
    "ImageGallery": [
        "R",
        "U",
        "D"
    ],
    "Transactions": [
        "R"
    ],
    "EmailTemplate": [
        "R",
        "U",
        "TE",
        "D",
        "C"
    ],
    // "MultiLanguage": [
    //     "R",
    //     "C",
    //     "U"
    // ],
    "DemographReport": [
        "R"
    ],
    "BannerManagement": [
        "R",
        "C",
        "U",
        "D"
    ],
    "CasinoManagement": [
        "R",
        "C",
        "U",
        "T",
        "D"
    ],
    "KpiSummaryReport": [
        "R"
    ],
    "LivePlayerReport": [
        "R"
    ],
    "WageringTemplate": [
        "R",
        "C",
        "U"
    ],
    "CashierManagement": [
        "R",
        "U",
        "T"
    ],
    // "LoyaltyManagement": [
    //     "R",
    //     "U"
    // ],
    "RegistrationField": [
        "R",
        "U"
    ],
    // "RestrictedCountry": [
    //     "R",
    //     "U",
    //     "D"
    // ],
    "SiteConfiguration": [
        "R",
        "U"
    ],
    "TransactionsDriver": [
        "R",
        "C",
        "U",
        "D",
        "T"
    ],
    "TransactionsBanking": [
        "R",
        "C",
        "U",
        "D",
        "T"
    ],
    "PlayerLiabilityReport": [
        "R"
    ],
    "PlayerManagementReport": [
        "R"
    ],
    "PromoCode": [
        "R",
        "C",
        "U",
        "D",
    ],
    "Promotions": [
        "R",
        "C",
        "U",
        "D",
    ],
    "CasinoCategory": [
        "R",
        "C",
        "U",
        "D",
        "T",
    ],
    "SportsBook": [
        "R",
    ]
}


export const ROLE_ENUMS = {
    SUPERADMIN: 1,
    ADMIN: 2,
    MANAGER: 3,
    STAFF: 4
  }
  